document.addEventListener("DOMContentLoaded", function() {
    const image = document.querySelector('.image-with-text__media img');

    if (image) {
        window.addEventListener('scroll', function() {
            const scrollPosition = window.scrollY;
            const scaleValue = 1 + scrollPosition / 1000;
            image.style.transform = `scale(${scaleValue})`;
        });
    }
});